export const getAddExamModalSteps = (t) => [
    {
        target: '[data-tour="aem-modal"]',
        placement: 'center',
        title: t('tour.addExamModal.step-welcome-title'),
        content: t('tour.addExamModal.step-welcome-content'),
        disableBeacon: true,
    },
    {
        target: '[data-tour="aem-date"]',
        title: t('tour.addExamModal.step-date-title'),
        content: t('tour.addExamModal.step-date-content'),
        disableBeacon: true,
    },
    {
        target: '[data-tour="aem-type"]',
        title: t('tour.addExamModal.step-type-title'),
        content: t('tour.addExamModal.step-type-content'),
        disableBeacon: true,
    },
    {
        target: '[data-tour="aem-upload"]',
        title: t('tour.addExamModal.step-upload-title'),
        content: t('tour.addExamModal.step-upload-content'),
        disableBeacon: true,
    },
    {
        target: '[data-tour="aem-footer"]',
        title: t('tour.addExamModal.step-footer-title'),
        content: t('tour.addExamModal.step-footer-content'),
        disableBeacon: true,
    },
];
